import { Button } from "antd";
import { useNavigate } from "react-router";
import { useContext, useState } from "react";
import moment from "moment";
import { ArrowLeft, Plus } from "lucide-react";

import FormsList from "./FormsList";
import SubscriptionModal from "./SubscriptionModal";
import { getSubscriptionUserInfo } from "../../utils/utils";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const Web2LeadContainer = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { isWebToLeadCreate } = useContext(AuthContext);
  const subscription = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(subscription?.validTo);
  const isExpired = validToDate.isBefore(currentDate);
  const dayDiff = currentDate.diff(validToDate, "days");

  const [isOpen, setIsOpen] = useState(false);

  const checkPermission = () => {
    if (!isWebToLeadCreate) {
      showAlert(
        "warning",
        "Permission Denied",
        "You do not have permission to access this resource",
      );
    } else {
      navigate("/settings/web-to-lead/create-form");
    }
  };

  const showModal = () => {
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div className="web-to-lead tw-font-inter">
      <div className="d-flex justify-content-center p-20">
        <div style={{ width: "100%" }}>
          <div className="tw-mb-6 tw-flex tw-items-center tw-gap-4">
            <div
              className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-p-2 tw-bg-slate-100 hover:tw-bg-slate-200/60 tw-text-slate-600 tw-transition-colors"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={18} />
            </div>
            <div className="tw-flex tw-flex-col tw-justify-center tw-gap-0.5">
              <h1 className="tw-text-xl tw-font-bold tw-mb-0 tw-text-slate-800 tw-font-inter">
                Web to Leads Setup
              </h1>
              <p className="tw-text-xs tw-mb-0 tw-text-slate-500 tw-font-medium">
                Generate embedded HTML or widget forms, map custom lead capture configurations, and generate standard contact capture links.
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center mt20">
            <Button
              type="primary"
              className="tw-btn-premium tw-my-2"
              onClick={() => {
                if (!subscription?.id || (isExpired && dayDiff > 7)) {
                  showModal();
                } else {
                  checkPermission();
                }
              }}
            >
              <Plus size={16} /> Create New Form
            </Button>
          </div>
          <FormsList onSubscription={() => setIsOpen(true)} />
          <SubscriptionModal isOpen={isOpen} handleCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default Web2LeadContainer;
